// Tooltip estilizado reutilizable (mismo look que el del tab Plantilla PRM):
// popover oscuro posicionado al vuelo bajo el elemento. Uso: v-tip="'texto'".
// Un único nodo compartido para todas las instancias. Reutilizar en este y demás tabs.

let node = null

function ensure () {
  if (node) return node
  node = document.createElement('div')
  node.style.cssText = [
    'position:fixed', 'z-index:9999', 'max-width:240px', 'padding:6px 9px',
    'border-radius:6px', 'background:#1e3046', 'color:#fff', 'font-size:11px',
    'line-height:1.4', 'white-space:pre-wrap', 'box-shadow:0 4px 14px rgba(30,48,70,.25)',
    'pointer-events:none', 'opacity:0', 'transition:opacity .1s', 'left:0', 'top:0',
  ].join(';')
  document.body.appendChild(node)
  return node
}

function show (target, text) {
  if (!text) return
  const t = ensure()
  t.textContent = text
  // Medimos el tamaño real del tooltip para centrarlo bajo el elemento (no asumir el ancho máximo).
  const r = target.getBoundingClientRect()
  const tw = t.offsetWidth
  const th = t.offsetHeight
  let left = r.left + r.width / 2 - tw / 2
  left = Math.max(8, Math.min(left, window.innerWidth - tw - 8))
  let top = r.bottom + 6
  if (top + th > window.innerHeight - 8) top = r.top - th - 6 // no cabe abajo: lo ponemos arriba
  t.style.left = left + 'px'
  t.style.top = top + 'px'
  t.style.opacity = '1'
}

function hide () {
  if (node) node.style.opacity = '0'
}

export const tip = {
  bind (el, binding) {
    el.__tipText = binding.value
    el.__tipEnter = () => show(el, el.__tipText)
    el.__tipLeave = hide
    el.addEventListener('mouseenter', el.__tipEnter)
    el.addEventListener('mouseleave', el.__tipLeave)
  },
  update (el, binding) {
    el.__tipText = binding.value
  },
  unbind (el) {
    el.removeEventListener('mouseenter', el.__tipEnter)
    el.removeEventListener('mouseleave', el.__tipLeave)
    hide()
  },
}
